import jun5Image from '../assets/jun5.jpeg';
import jun6Image from '../assets/jun6.jpeg';

export const events = [
  {
    id: 'retro-bar-dj-night-06-05',
    date: '2026-06-05',
    formattedDate: 'Jun 5, 2026',
    formattedDateLong: 'June 5, 2026',
    day: 'Friday',
    title: 'Bolly - Tolly Rave',
    subtitle: 'DJ NIGHT',
    djName: 'RETRO BAR',
    djDescription: 'DJ Night',
    image: jun5Image,
    time: '10:00 PM',
    specialOffer: null,
    description: 'Experience DJ Night at The Retro Street. Get ready for an unforgettable Friday night of music, energy, and pure entertainment.',
    bookingUrl: 'https://retro-bar-tx.maghil.com/restaurant/retro-bar-tx/menu/Pickup/event/retro-bar-dj-night-06-05'
  },
  {
    id: 'retro-bar-dj-night-06-06',
    date: '2026-06-06',
    formattedDate: 'Jun 6, 2026',
    formattedDateLong: 'June 6, 2026',
    day: 'Saturday',
    title: 'Party till 4 AM',
    subtitle: 'DJ NIGHT',
    djName: 'RETRO BAR',
    djDescription: 'DJ Night',
    image: jun6Image,
    time: '10:00 PM',
    specialOffer: null,
    description: 'Experience DJ Night at The Retro Street. Get ready for an unforgettable Saturday night of music, energy, and pure entertainment.',
    bookingUrl: 'https://retro-bar-tx.maghil.com/restaurant/retro-bar-tx/menu/Pickup/event/retro-bar-dj-night-06-06'
  }
];
